import { IPropertyDetails } from '@/app/actions/serverActions';
import Link from 'next/link';

export default function PropertyBreadcrumbs({
  destination,
  area,
}: {
  destination: IPropertyDetails['destination'];
  area: IPropertyDetails['destination'];
}) {
  return (
    <nav className="text-md uppercase">
      <Link href={`/explore?destination=${destination.name}`}>{destination.label}</Link>
      <span className="text-nowrap mx-2">•</span>
      <span className="font-semibold">{area.label}</span>
    </nav>
  );
}
